export function parseSystemUrl(hostname){

  if (!hostname) {
    return undefined;
  }

  var 
    localhost = /.*localhost$/,
    ipiranga = /.*wgs-ipiranga.*/,
    prod = /.*wgs-prod.*/,
    prodNew = /.*departure-board.wegoshare.com.*/

  if (localhost.test(hostname)) {
    return 'services.porto.qa.wegoshare.com';
  } else if (ipiranga.test(hostname)){
    return 'services.porto.qa.wegoshare.com';
  } else if (prod.test(hostname) || prodNew.test(hostname)){
    return 'services.qmob.pt';
  }

  return undefined;
}